export const MAX_BASE_STAT = 255
export const MAX_BASE_EXPERIENCE = 635

export const BASE_STATS = {
	hp: {
		label: 'HP',
		color: '#D53B47'
	},
	attack: {
		label: 'ATK',
		color: '#FBA924'
	},
	defense: {
		label: 'DEF',
		color: '#0291EF'
	},
	speed: {
		label: 'SPD',
		color: '#91AFC6'
	},
	base_experience: {
		label: 'EXP',
		color: '#398C3C'
	}
}
